import React, { Component as C } from "react"
import { curry, assign } from "lodash"
import shallowEqual from "./shallowEqual.es6"

const connectToStores = (Spec, Component) => {
  return class extends C {
    constructor(props) {
      super(props)
      this.getPropsFromStores = Spec.getPropsFromStoresFactory
        ? Spec.getPropsFromStoresFactory(this.props)
        : Spec.getPropsFromStores

      if (this.getPropsFromStores != null) {
        this.state = this.getPropsFromStores(this.props)
      }

      this.propsFromActions =
        Spec.getPropsFromActions != null ? Spec.getPropsFromActions(this.props) : {}

      this.getStaticProps = Spec.getStaticPropsFactory
        ? Spec.getStaticPropsFactory(this.props)
        : Spec.getStaticProps

      this.staticProps = this.getStaticProps != null ? this.getStaticProps(this.props) : {}
    }

    shouldComponentUpdate() {
      return this._shouldUpdate
    }

    componentWillReceiveProps(nextProps, nextContext) {
      this.onChange(nextProps)
    }

    componentDidMount() {
      const stores = Spec.getStores(this.props)

      this.storeListeners = stores.map((store) => {
        return store.listen(() => {
          this.onChange(this.props)
        })
      })

      this.onChange(this.props)
    }

    componentWillUnmount() {
      for (const unlisten of this.storeListeners) {
        unlisten()
        continue
      }
    }

    onChange(props) {
      if (this.getPropsFromStores == null) {
        this._shouldUpdate = !shallowEqual(this.props, props)
        return
      }

      const nextPropsFromStores = this.getPropsFromStores(props)

      this._shouldUpdate =
        !shallowEqual(this.props, props) || !shallowEqual(this.state, nextPropsFromStores)

      if (this._shouldUpdate) {
        this.setState(nextPropsFromStores)

        this.propsFromActions =
          Spec.getPropsFromActions != null ? Spec.getPropsFromActions(props) : this.propsFromActions

        this.staticProps = this.getStaticProps != null ? this.getStaticProps(props) : {}
      }
    }

    render() {
      const mergedProps =
        Spec.mergeProps != null
          ? Spec.mergeProps(this.state, this.propsFromActions, this.staticProps, this.props)
          : assign({}, this.state, this.propsFromActions, this.staticProps, this.props)

      return <Component {...mergedProps} />
    }
  }
}

export default curry(connectToStores)
